import { Routes } from '@angular/router';
import { StartComponent } from './pages/start/start.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SoftwareDevelopmentComponent } from './pages/software-development/software-development.component';
import { PhotographyComponent } from './pages/photography/photography.component';
import { RealEstateComponent } from './pages/real-estate/real-estate.component';
import { BlitzshareComponent } from './pages/blitzshare/blitzshare.component';
import { TrumpPostAlertComponent } from './pages/trump-post-alert/trump-post-alert.component';
import { ImprintComponent } from './pages/imprint/imprint.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { SupportComponent } from './pages/support/support.component';
import { ContactComponent } from './pages/contact/contact.component';

export const appRoutes: Routes = [
  { path: '', component: StartComponent, pathMatch: 'full' },
  { path: 'software-development', component: SoftwareDevelopmentComponent },
  { path: 'photography', component: PhotographyComponent },
  { path: 'real-estate', component: RealEstateComponent },
  { path: 'blitzshare', component: BlitzshareComponent },
  { path: 'trump-post-alert', component: TrumpPostAlertComponent },
  { path: 'imprint', component: ImprintComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'support', component: SupportComponent },
  { path: 'contact', component: ContactComponent },
  { path: '**', component: NotFoundComponent },
];
